import React, {useEffect, useState} from 'react'
import { useNavigate, useParams, Link } from 'react-router-dom';
import './Talent.css';

import Header from '../../sections/Header/Header'
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import PreviewSlider from '../../components/Slider/PhotoSlider/PhotoSlider';

import { getPublicModels, isPremiumActive, modelProfilePath } from '../../../services/modelService';
import { getModelPhotos } from '../../../util/ModelPhotos';

const Talent = () => {
    const navigate = useNavigate();
    const {city} = useParams();
    const [models, setModels] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const handleCityChange = (event) => navigate(event.currentTarget.value);

    useEffect(() => {
        let mounted = true;
        setLoading(true);
        setError('');
        getPublicModels(city)
            .then((items) => { if (mounted) setModels(items); })
            .catch((loadError) => { if (mounted) setError(loadError.message || 'We could not load the model profiles.'); })
            .finally(() => { if (mounted) setLoading(false); });
        window.scrollTo(0, 0);
        return () => { mounted = false; };
    }, [city]);

    const cityTitle = city ? city.charAt(0).toUpperCase() + city.slice(1) : '';

    return (
        <>
            <SEO title={city ? `Escort Agency ${cityTitle} • Elite Talent` : 'Elite Escort Talent Italy • Rome, Milan'} description={city ? `Browse elite escort talent in ${cityTitle}, Italy. Premium adult entertainment agency with luxury companions.` : 'Browse elite escort talent across Italy. Premium adult entertainment agency in Rome, Milan, and more.'} />
            <Header />
            <section className="section-header">
                <div className="view-container">
                    <h1>Talent <span>{city}</span></h1>
                    <p>Our agency represents the best talent in the industry, offering a diverse roster of top-tier performers who consistently deliver exceptional results.</p>
                    <div className="city-selector">
                        <span>City:</span><select value={city ? `/talent/${city}` : '/talent'} onChange={handleCityChange}>
                            <option value="/talent">All</option>
                            <option value="/talent/rome">Rome</option>
                            <option value="/talent/milan">Milan</option>
                        </select>
                    </div>
                </div>
            </section>
            <section className="fantasy-cta">
                <div className="view-container">
                    <Link to={'/fantasy'} className="fantasy-cta-link">Custom Fantasy Experience →</Link>
                </div>
            </section>
            <section className="talent-wall talent-page">
                {loading && <p className="talent-feedback">Loading talent...</p>}
                {!loading && error && <p className="talent-feedback" role="alert">{error}</p>}
                {!loading && !error && models.map((model, index) => (
                    <PreviewSlider
                        key={`${model.uuid || model.slug || model.name}-${index}`}
                        col={4}
                        images={getModelPhotos(model)}
                        name={model.name}
                        city={model.city || cityTitle}
                        link={modelProfilePath(model.citySlug || model.city || city, model)}
                        featured={isPremiumActive(model)}
                    />
                ))}
            </section>
            <Footer />
        </>
    )
}

export default Talent;
